import { createTheme } from '@mui/material/styles';
import { darkPalette, lightPalette, } from '@uipath/apollo-core';
import defaultsDeep from 'lodash/defaultsDeep';
import breakpoints from './breakpoints';
import { darkOverrides, lightOverrides, } from './overrides';
import spacing from './spacing';
import typography from './typography';
const globalPropOverrides = {
    MuiTextField: { defaultProps: { InputLabelProps: { shrink: true } } },
    MuiButton: { defaultProps: { disableFocusRipple: true } },
    MuiTab: { defaultProps: { disableRipple: true } },
};
const getGlobalVariantOverrides = (palette) => ({
    MuiTypography: {
        variants: [
            {
                props: { color: 'primary' },
                style: { color: palette.semantic.colorPrimary },
            },
            {
                props: { color: 'textPrimary' },
                style: { color: palette.semantic.colorForegroundDeEmp },
            },
            {
                props: { color: 'textSecondary' },
                style: { color: palette.semantic.colorForegroundDeEmp },
            },
        ],
    },
    MuiIconButton: {
        variants: [
            {
                props: { color: 'default' },
                style: { color: palette.semantic.colorIconDefault },
            },
        ],
    },
});
const apolloMaterialUiThemeLight = createTheme({
    palette: {
        ...lightPalette,
        mode: 'light',
    },
    spacing,
    breakpoints,
    components: defaultsDeep(lightOverrides, globalPropOverrides, getGlobalVariantOverrides(lightPalette)),
    typography,
});
const apolloMaterialUiThemeDark = createTheme({
    palette: {
        ...darkPalette,
        mode: 'dark',
    },
    spacing,
    breakpoints,
    components: defaultsDeep(darkOverrides, globalPropOverrides, getGlobalVariantOverrides(darkPalette)),
    typography,
});
export { apolloMaterialUiThemeLight, apolloMaterialUiThemeDark, };
